/**
 * @file: LeadSearchBox.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The search field at the top of the filter panel. Edits flow up immediately;
 * the owning hook debounces the value into the actual `keyword` query.
 */

import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Search } from 'lucide-react-native';
import { memo } from 'react';
import { TextInput, View } from 'react-native';

export const LeadSearchBox = memo(
  ({
    value,
    onChange,
  }: {
    value: string;
    onChange: (text: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          marginHorizontal: rpx(16),
          marginBottom: rpx(14),
          paddingHorizontal: rpx(14),
          height: rpx(44),
          borderRadius: rpx(12),
          backgroundColor: LD.surface,
          borderWidth: 1,
          borderColor: LD.hairline,
        }}
      >
        <Search size={rpx(18)} color={LD.mist} />
        <TextInput
          value={value}
          onChangeText={onChange}
          placeholder="搜索车牌、客户或手机号"
          placeholderTextColor={LD.mist}
          returnKeyType="search"
          clearButtonMode="while-editing"
          style={{
            flex: 1,
            marginLeft: rpx(10),
            fontSize: rpx(15),
            color: LD.ink,
            padding: 0,
          }}
        />
      </View>
    );
  },
);
